import { useState } from "react";
import { MdPerson } from "react-icons/md";
import ProfileModal from "./Modal";

function Profile({ project, updateStatus }) {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  return (
    <>
      <div className="mutualMobility-contact rounded" onClick={onOpen}>
        <MdPerson size={24} />
      </div>
      <ProfileModal
        open={open}
        updateStatus={updateStatus}
        onClose={onClose}
        project={project}
      />
    </>
  );
}

export default Profile;
